import { DeletePairAssignmentsInput11fmeg9pssfu8 as DeletePairAssignmentsInput } from './schema/type/DeletePairAssignmentsInput.mjs';
import { DeletePairAssignmentsMutationfwlgebyv0y4l as DeletePairAssignmentsMutation } from './schema/DeletePairAssignmentsMutation.mjs';
import { voidResult3hb4jxf0f2mcw as voidResult } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/VoidResult.mjs';
import { Dispatcher2k7js8ct0qtp5 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/DeletePairAssignmentsCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  // Inline function 'kotlin.with' call
  var tmp0_safe_receiver = (yield* this.a6u(new (DeletePairAssignmentsMutation())(new (DeletePairAssignmentsInput())(command.u2j_1, command.v2j_1)), $completion)).d42_1;
  // Inline function 'kotlin.let' call
  var tmp$ret$2 = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e6e_1) === true;
  return voidResult(tmp$ret$2);
}
var SdkDeletePairAssignmentsCommandDispatcherClass;
function SdkDeletePairAssignmentsCommandDispatcher() {
  if (SdkDeletePairAssignmentsCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkDeletePairAssignmentsCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkDeletePairAssignmentsCommandDispatcherClass = $;
  }
  return SdkDeletePairAssignmentsCommandDispatcherClass;
}
//region block: exports
export {
  SdkDeletePairAssignmentsCommandDispatcher as SdkDeletePairAssignmentsCommandDispatcher3r89xhj6g83sl,
  perform as perform2289fmh0idzb8,
};
//endregion

//# sourceMappingURL=SdkDeletePairAssignmentsCommandDispatcher.mjs.map
